"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class ZoningClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.entityPath = 'zonings';
    }
    create(projectId, zoning) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/zonings`, zoning);
            return response.payload;
        });
    }
    update(projectId, zoningId, zoning) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/zonings/${zoningId}`, zoning);
            return response.payload;
        });
    }
    delete(projectId, zoningId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/zonings/${zoningId}`);
            return response.payload;
        });
    }
    getZoning(projectId, id, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${id}?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getZonings(projectId, fields, ids, includeDeleted, includeCounts = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings?${this.getQueryString({
                fields,
                ids,
                includeDeleted,
                includeCounts,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getZoningsV2(projectId, searchRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings?${this.getQueryString(searchRequest)}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    migrateZoning(projectId, zoningId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/zonings/migrate/${zoningId}`);
            return response.payload;
        });
    }
    getZoningsByPage(projectId, pageId, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/pages/${pageId}/zonings?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    createZones(projectId, zoningId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/zonings/${zoningId}/zones`, payload);
            return response.payload;
        });
    }
    getZone(projectId, id, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones/${id}?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getZones(projectId, zoningId, fields, ids, flat) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/zones?${this.getQueryString({ fields, ids, flat })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getZonesByProject(projectId, fields, ids, zoningIds, names) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones?${this.getQueryString({ fields, ids, zoningIds, names })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    updateZone(projectId, zoneId, requestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zones/${zoneId}`;
            const response = yield this.httpPut(url, requestPayload);
            return response.payload;
        });
    }
    searchSnapshotsFromRecordedPageviews(projectId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/retroactive?${this.getQueryString(context)}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    postSnapshotFeedback(projectId, feedback) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/retroactive/feedback`;
            const response = yield this.httpPost(url, feedback);
            return response.payload;
        });
    }
    createSettings(projectId, zoningId, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/settings?hash=${hash}`;
            const response = yield this.httpPost(url);
            return response.payload;
        });
    }
    fetchSettings(projectId, zoningId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/settings`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getZonesIssues(projectId, zoningId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/zones-issues?${this.getQueryString(context)}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    postZoneIssueFeedback(projectId, zoningId, feedback) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/zones-issues/feedback`;
            const response = yield this.httpPost(url, feedback);
            return response.payload;
        });
    }
}
exports.ZoningClient = ZoningClient;
//# sourceMappingURL=zoning.client.js.map